import React, { Component } from "react";
import "./NodeModal.css";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  FormGroup,
  Input,
  Label,
} from "reactstrap";

export default class UserAddModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      userEmail: "",
      users: this.props.users,
      validationError: [],
      isValid: true,
      loading:false,
    };
  }

  validateInput = () => {
    let errors = [];
    if (
      /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(
        this.state.userEmail
      )
    ) {
      let found = false;
      this.state.users.forEach((user) => {
        if(user.email === this.state.userEmail){
          found = true;
        }
      });
      if(found){
        errors.push(<li key={"email"}>User is already in the network</li>);
          this.setState({ isValid: false, validationErrors: errors });
          return false;
      }
      this.setState({ isValid: true, validationErrors: [] });
      return true;
    }
    errors.push(<li key={"email"}>Enter a valid email address</li>);
    this.setState({ isValid: false, validationErrors: errors });
    return false;
  };

  handleChange = (e) => {
    let email = e.target.value;
    this.setState({ userEmail: email });
  };

  render() {
    const { toggle, toggleName, getErrors, onSave } = this.props;

    return (
      <Modal modalClassName="Modal" isOpen={true} toggle={function(){ return toggle(toggleName);}}>
        <ModalHeader>
          Add user
          <button className="exit_close_button" onClick={function(){ return toggle(toggleName)}}>
            ×
          </button>
        </ModalHeader>

        <div className="val_error_area">
          <ul style={{ color: "red" }}>
            {this.state.isValid ? getErrors() : this.state.validationErrors}
          </ul>
        </div>
        <ModalBody>
          <Form
            onSubmit={(event) => {
              event.preventDefault();
            }}
          >
            <FormGroup className="fg">
              <Label for="userEmail">Email</Label>
              <Input
                type="text"
                name="userEmail"
                value={this.state.userEmail}
                onChange={this.handleChange}
                placeholder="Enter user email"
                maxLength="100"
              />
            </FormGroup>
          </Form>
        </ModalBody>
        <ModalFooter>
          <button
            className="save_button"
            color="success"
            disabled={this.state.loading}
            onClick={async() => {
              this.setState({ loading: true });
              if (this.validateInput()) {
                let valid = await onSave(this.state.userEmail);
                if (!valid) {
                  this.setState({ isValid: valid });
                  await this.setState({ validationErrors: getErrors() });
                }
              }
              this.setState({ loading: false });
            }}
          >
            {this.state.loading ? "Add user..." : "Add user"}
          </button>
        </ModalFooter>
      </Modal>
    );
  }
}
